import { Injectable, DOCUMENT, inject } from "@angular/core";

import { EnvironmentUtilsService } from "./environment-utils.service";

@Injectable({
  providedIn: "root",
})
export class SubDomainService {
  private readonly document = inject<Document>(DOCUMENT);
  private readonly utilitiesService = inject(EnvironmentUtilsService);

  private static DOMAIN_LEVEL_SEPARATOR = ".";

  private get location(): Location {
    return this.document.location;
  }

  private get domainLevels(): string[] {
    const { hostname } = this.location; // e.g. subdomain.example.com
    return hostname.split(SubDomainService.DOMAIN_LEVEL_SEPARATOR);
  }

  private get rootDomainLevelsCount(): number {
    return this.utilitiesService.isLocalEnv() ? 1 : 3;
  }

  public get subDomain(): string | undefined {
    return this.domainLevels.slice(0, -this.rootDomainLevelsCount).at(0);
  }

  public get rootDomain(): string {
    return this.domainLevels
      .filter((level) => level !== this.subDomain)
      .join(SubDomainService.DOMAIN_LEVEL_SEPARATOR);
  }

  public get rootOrigin(): string {
    const { origin } = this.location; // e.g. https://subdomain.example.com:443
    return this.subDomain
      ? origin.replace(this.subDomain + SubDomainService.DOMAIN_LEVEL_SEPARATOR, "")
      : origin;
  }

  public get fallbackLoginUrl(): string {
    return this.rootOrigin + "/login";
  }
}
